/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { CMSBanner } from '../CMSBanner/CMSBanner';
import type { ContentStackCitrusAd, SizePerDevice } from '../../interface';
import { mapCitrusBannerToContentStackBanner } from '@/features/citrus/utils/mapCitrusBannerToContentStackBanner';
import { type CitrusAd } from '@/features/citrus';
import { isCitrusBannerWithLink } from '@/features/citrus/utils/isCitrusBannerWithLink';
import { useLabels } from '@/hooks/useLabels';

type Props = {
  content: ContentStackCitrusAd;
  citrusAds?: CitrusAd[];
  priority?: boolean;
  sizePerDevice?: SizePerDevice;
  SpacerComponent: React.ComponentType<{ children: React.ReactNode; id?: string }>;
};

const labelMap = {
  clickForDetails: 'label_click_for_details',
} as const;

export function CMSCitrus({
  content,
  citrusAds = [],
  priority,
  sizePerDevice,
  SpacerComponent,
}: Props) {
  const labels = useLabels(labelMap);
  const bannersToDisplay = citrusAds.find((adSlot) => adSlot.slotId === content.slot_id);

  return (
    <>
      {bannersToDisplay?.banners?.map((item, i) =>
        isCitrusBannerWithLink(item) ? (
          <SpacerComponent
            key={i}
            {...(mapCitrusBannerToContentStackBanner(item, labels.clickForDetails).component_id && {
              id: mapCitrusBannerToContentStackBanner(item, labels.clickForDetails).component_id,
            })}
          >
            <CMSBanner
              content={mapCitrusBannerToContentStackBanner(item, labels.clickForDetails)}
              sponsored
              citrusInfo={{ citrusAdId: item.citrusAdId }}
              priority={priority}
              sizePerDevice={sizePerDevice}
            />
          </SpacerComponent>
        ) : null,
      )}
    </>
  );
}
